// No browser/Web Push notifications. Only in-page ringing sound.
let context = null, timer = null;
export async function unlockCallRingtone() {
  context ??= new (window.AudioContext || window.webkitAudioContext)();
  if (context.state === 'suspended') await context.resume();
}
function tone() {
  if (!context || context.state !== 'running') return;
  for (const [frequency, delay] of [[740,0],[940,.22]]) {
    const at = context.currentTime + delay;
    const osc = context.createOscillator(); const gain = context.createGain();
    osc.type = 'sine'; osc.frequency.value = frequency;
    gain.gain.setValueAtTime(.0001, at);
    gain.gain.exponentialRampToValueAtTime(.13, at + .03);
    gain.gain.exponentialRampToValueAtTime(.0001, at + .18);
    osc.connect(gain); gain.connect(context.destination);
    osc.start(at); osc.stop(at + .20);
  }
}
export function startCallRingtone() { stopCallRingtone(); tone(); timer = setInterval(tone, 1700); }
export function stopCallRingtone() { if (timer !== null) clearInterval(timer); timer = null; }

export async function removeLegacyCallPush() {
  if (!('serviceWorker' in navigator)) return;
  const registrations = await navigator.serviceWorker.getRegistrations();
  for (const reg of registrations) {
    const script = reg.active?.scriptURL || reg.waiting?.scriptURL || reg.installing?.scriptURL || '';
    if (script.includes('/gamepro-admin-sw.js')) {
      await reg.pushManager?.getSubscription().then(sub => sub?.unsubscribe()).catch(() => {});
      await reg.unregister();
    }
  }
}
